import React, { Component, Fragment } from 'react';
import { SGDocsContainer, DocsFlexContainer, Header, NOTES } from './uploadDocSG.styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './upload-docs-sg.css';
import { change, touch } from 'redux-form';
import { ACCEPT_ICON, CLOSE_HEAVY_ICON, REJECT_ICON, SAMPLE } from '@Images';
import {
  DocumentTimeline,
  ModalFactory,
  BackButton,
  CommonButton,
  FileUploadLinksNew
} from '@Components';
import styled from 'styled-components';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import toLower from 'lodash/toLower';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { SAMPLE_DOC_IMAGE, infoPoints } from '../../../../utils/constants';
import { GenerateField } from './UploadDocSGFieldRenderer';

const Submission = styled.div`
  margin: 68px 0px 70px 10px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

class UploadDocSG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageMetaData: {
        front: {
          actual_file_name: null,
          fileSrc: null
        },
        back: {
          actual_file_name_back: null,
          fileSrcBack: null
        }
      },
      showSample: false,
      samplePopupStyle: {},
      sampleImageUrl: SAMPLE,
      is_aadhar_verified: false
    };
  }

  async UNSAFE_componentWillMount() {
    await this.buildImageMetaData();
  }
  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    if (
      !isEqual(nextProps.fieldscustom, this.props.fieldscustom) ||
      !isEqual(nextProps.clearFile, this.props.clearFile)
    ) {
      await this.buildImageMetaData(nextProps.fieldscustom);
    }
    const { is_aadhar_details_accepted, country_code, getAllformVal } = nextProps;
    if (country_code === 'IN' && is_aadhar_details_accepted) {
      const isPanEVerified = get(getAllformVal, 'panEVerified', false);
      const name_matched = get(getAllformVal, 'name_matched', false);
      this.setState({
        is_aadhar_verified: isPanEVerified ? name_matched : true
      });
    }
  };

  buildImageMetaData = async (fieldscustom = this.props.fieldscustom) => {
    if (fieldscustom) {
      let visibleElem = '';
      Object.keys(fieldscustom).forEach((key) => {
        if (fieldscustom[key] && Array.isArray(fieldscustom[key])) {
          fieldscustom[key].forEach((child) => {
            if (child.is_doc_render_visible) {
              visibleElem = key;
              return false;
            }
          });
          if (visibleElem) {
            return false;
          }
        }
      });
      let fieldsArray = fieldscustom[visibleElem];
      let callApi = true;
      if (fieldsArray && Array.isArray(fieldsArray)) {
        if (fieldsArray && fieldsArray[0] && fieldsArray[0].linkConfig) {
          let imgDataArray = this.state.imageMetaData;
          if (fieldsArray[0].linkConfig.fileSrc) {
            callApi = false;
            imgDataArray.front.fileSrc = fieldsArray[0].linkConfig.fileSrc;
            imgDataArray.front.actual_file_name = fieldsArray[0].linkConfig.actual_file_name;
          } else {
            callApi = true;
            imgDataArray.front.fileSrc = null;
            imgDataArray.front.actual_file_name = null;
          }
          if (fieldsArray[0].linkConfig.fileSrcBack) {
            imgDataArray.back.fileSrcBack = fieldsArray[0].linkConfig.fileSrcBack;
            imgDataArray.back.actual_file_name_back =
              fieldsArray[0].linkConfig.actual_file_name_back;
          } else {
            imgDataArray.back.fileSrcBack = null;
            imgDataArray.back.actual_file_name_back = null;
          }
          await this.setState({ imageMetaData: imgDataArray });
          this.props.dispatch(change(this.props.formName, 'call_doc_upload_api', callApi));
        }
      }
    }
    this.props.dispatch(
      change(this.props.formName, 'currentDocScreen', this.props.currentDocScreen)
    );
    this.props.dispatch(change(this.props.formName, 'currentDocTimeLine', this.props.timeLine));
    window.scrollTo(0, 0);
  };

  resetValue = (fieldName) => {
    const { getAllformVal } = this.props;
    if (
      getAllformVal &&
      getAllformVal.asyncValidateMsg &&
      getAllformVal.asyncValidateMsg[fieldName]
    ) {
      const asyncValidateMsg = getAllformVal.asyncValidateMsg;
      delete asyncValidateMsg[fieldName];
      this.props.dispatch(change(this.props.formName, 'asyncValidateMsg', asyncValidateMsg));
    }
  };

  renderFieldJSON = (fieldJson, disableField) => {
    const { getAllformVal } = this.props;
    return fieldJson.map((field) => {
      return (
        <GenerateField
          field={field}
          getAllformVal={getAllformVal}
          disableField={disableField}
          resetValue={this.resetValue}
          key={field.name}
        />
      );
    });
  };

  resetImageData = async () => {
    await this.setState({
      imageMetaData: {
        front: {
          actual_file_name: null,
          fileSrc: null
        },
        back: {
          actual_file_name_back: null,
          fileSrcBack: null
        }
      }
    });
  };

  clearFile = ({ setState, fileName, clearOnly }) => {
    let currentFieldState = this.state.imageMetaData;
    if (clearOnly === 'fileSrc') {
      if (currentFieldState.front.fileSrc) {
        currentFieldState.front.actual_file_name = null;
        currentFieldState.front.fileSrc = null;
      }
    } else if (clearOnly === 'fileSrcBack') {
      if (currentFieldState.back.fileSrcBack) {
        currentFieldState.back.actual_file_name_back = null;
        currentFieldState.back.fileSrcBack = null;
      }
    }
    this.setState({ imageMetaData: currentFieldState });
    if (setState) {
      this.props.dispatch(change(this.props.formName, fileName, ''));
    }
  };

  onChangeFile = ({
    target,
    docTypeString,
    document_code,
    is_back_file,
    webcamData,
    isInvalid,
    type
  }) => {
    if (webcamData) {
      let { dataURL, fileName, extension, imageObj, fieldName } = webcamData;
      this.setFile({
        dataURL,
        fileName: fileName + extension,
        document_code,
        is_back_file,
        docTypeString,
        type
      });
      this.props.dispatch(change(this.props.formName, fieldName, imageObj));
      this.props.dispatch(touch(this.props.formName, fieldName));
      return;
    }
    let input = target,
      dataURL,
      reader = new FileReader();
    reader.readAsDataURL(input.files[0]);
    reader.onload = () => {
      // to get dataURL
      dataURL = reader.result;
      this.setFile({
        dataURL,
        fileName: input.files[0].name,
        document_code,
        is_back_file,
        docTypeString,
        isInvalid,
        type
      });
      input.value = ''; //to allow re-selecting of the same file
    };
  };

  setFile = async ({ dataURL, fileName, is_back_file, isInvalid }) => {
    this.props.dispatch(change(this.props.formName, 'call_doc_upload_api', true));
    let imgDataArray = this.state.imageMetaData;
    if (!is_back_file) {
      imgDataArray.front.actual_file_name = fileName;
      imgDataArray.front.fileSrc = isInvalid ? '' : dataURL;
    } else if (is_back_file) {
      imgDataArray.is_back_file = true;
      imgDataArray.back.actual_file_name_back = fileName;
      imgDataArray.back.fileSrcBack = isInvalid ? '' : dataURL;
    }
    await this.setState({ imageMetaData: imgDataArray });
  };

  renderUploadLinks = (props, currentScreen) => {
    // need to create new variable to make upload links work
    let { imageMetaData } = this.state;
    if (imageMetaData) {
      const {
        front: { actual_file_name, fileSrc },
        back: { actual_file_name_back, fileSrcBack },
        is_back_file
      } = imageMetaData;
      props['actual_file_name_back'] = actual_file_name_back;
      props['actual_file_name'] = actual_file_name;
      props['fileSrc'] = fileSrc;
      props['fileSrcBack'] = fileSrcBack;
      props['is_back_file'] = is_back_file;
    }

    let newObj = {
      disableForm: false,
      docTypeString: currentScreen,
      linkEle: props,
      index: 0,
      toggleFeature: true
    };
    let { linkEle } = newObj;
    let new_obj = Object.assign({}, JSON.parse(JSON.stringify({ ...newObj })));
    if (linkEle.document_input_type === 'FILE')
      return (
        <FileUploadLinksNew
          {...new_obj}
          clearFile={this.clearFile}
          onChangeFile={this.onChangeFile}
          formName={this.props.formName}
          country_code={this.props.country_code}
          currentScreen={this.props.currentScreen}
          account_type={this.props.account_type}
          validate={this.props.validate}
          isShowSamplePhoto={this.isShowSamplePhoto}
          onSampleClick={this.onSampleClick(newObj)}
          device={this.props.device}
        />
      );
    return null;
  };
  onSampleClick = (item) => async (el, isBackFile) => {
    const image = this.getSampleImage(item, isBackFile);
    await this.setState({ sampleImageUrl: image });
    this.showSampleModal();
  };

  getSampleImage = (item, isBackImage) => {
    const {
      linkEle: { document_code }
    } = item;
    let frontKey = document_code;
    if (isBackImage) {
      frontKey = `${frontKey}_BACK`;
    }
    return SAMPLE_DOC_IMAGE[frontKey] ? SAMPLE_DOC_IMAGE[frontKey] : SAMPLE;
  };
  renderScreen = (renderObject, currentScreen, renderLabel = true) => {
    if (!renderObject) {
      return null;
    }
    let submitButtonText = 'Save and continue';
    const nextScreenIndex = this.props.selectedScreenIndex + 1;
    const nextScreen = this.props.timeLine[nextScreenIndex];
    if (nextScreen && nextScreen.value) {
      submitButtonText = this.props.renderPOA
        ? 'Submit'
        : `Proceed to ${typeof nextScreen.value === 'string' && nextScreen.value.toLowerCase()}`;
    }
    const { country_code, getAllformVal } = this.props;
    const isPanEVerified = get(getAllformVal, 'panEVerified', false);
    const { is_aadhar_verified } = this.state;
    const isPanScreen = renderObject.document_code === 'PAN';
    const hideUploadDocFeature = is_aadhar_verified && isPanScreen;
    const isSubmitButtonDisabled = isPanScreen && !isPanEVerified;
    let points = [];
    if (infoPoints && infoPoints[currentScreen]) {
      points = infoPoints[currentScreen][country_code] || infoPoints[currentScreen]['DEFAULT'];
    }
    return (
      <Fragment>
        {renderLabel && <div className="updc-text-label">{renderObject.label}</div>}
        {renderObject.fields_json &&
          this.renderFieldJSON(renderObject.fields_json, renderObject.disableField)}

        <div className="updc-info-container">
          {!hideUploadDocFeature && (
            <Fragment>
              <div className="updc-info-title">{`Upload your ${toLower(renderObject.label)}`}</div>
              <div className="updc-info-text">JPEG, PNG or PDF only. Max size 5 MB</div>
              {points.map((item, index) => {
                return (
                  <div className="updc-points-container" key={index}>
                    <img alt="icon" src={item.type === 'accept' ? ACCEPT_ICON : REJECT_ICON} />
                    <div className="updc-info-points">{item.text}</div>
                  </div>
                );
              })}
              {this.renderUploadLinks(renderObject, currentScreen)}
              {country_code === 'IN' && currentScreen === 'POA' && (
                <NOTES id="document-discalimer">
                  If address given on personal info is not as per the uploaded document, we will
                  update it as per the proof of address in our records.
                </NOTES>
              )}
            </Fragment>
          )}
          <Submission disabled={isSubmitButtonDisabled}>
            <CommonButton
              text={submitButtonText}
              type="submit"
              disabled={isSubmitButtonDisabled}
              width={300}
              height={50}
            />
          </Submission>
        </div>
      </Fragment>
    );
  };
  showSampleModal = async () => {
    await ModalFactory.builder(
      (onClose) => (
        <div className="logo-modal">
          <img
            src={CLOSE_HEAVY_ICON}
            alt="close-icon"
            className="close"
            onClick={() => onClose(false)}
          />
          <img
            src={this.state.sampleImageUrl}
            alt="sample"
            style={{ width: '100%', padding: '50px' }}
          />
          <CommonButton
            className="close-text"
            text="Close"
            type="link"
            onClick={() => onClose(false)}
          />
        </div>
      ),
      'send-money-bene-modal insta-modal center-modal sample-modal',
      true
    );
  };

  render() {
    const { fieldscustom, getAllformVal, hideUploadDocScreen } = this.props;
    return (
      <DocsFlexContainer>
        <div className="updc-back-button">
          {this.props.selectedScreenIndex === 0 ? (
            <BackButton newOnboardingScreen={true} />
          ) : (
            <BackButton
              newOnboardingScreen={true}
              goBack={() => this.props.goBack(this.props.currentDocScreen)}
            />
          )}
        </div>
        <SGDocsContainer>
          <Header id="upload-doc-header">Upload documents</Header>
          {this.props.timeLine && this.props.timeLine.length > 1 && (
            <DocumentTimeline
              timeline={this.props.timeLine}
              currentScreen={this.props.currentDocScreen}
            />
          )}
          {fieldscustom &&
            !hideUploadDocScreen &&
            Object.keys(fieldscustom).map((item) => {
              if (!fieldscustom[item] || !Array.isArray(fieldscustom[item])) {
                return null;
              } else {
                return fieldscustom[item].map((child, childIndex) => {
                  if (!child.is_doc_render_visible) {
                    return null;
                  }
                  const renderObject = {
                    ...child.linkConfig,
                    ...{ disableField: child.disableField }
                  };
                  return (
                    <Fragment key={childIndex}>
                      {child.renderDropDown ? (
                        <Fragment>
                          {child.dropDownToRender}
                          {getAllformVal && getAllformVal[child.parentKey]
                            ? this.renderScreen(
                                find(child.dropDownConfig, {
                                  [child.parentKey]: getAllformVal[child.parentKey]
                                }),
                                item,
                                false
                              )
                            : null}
                        </Fragment>
                      ) : (
                        this.renderScreen(renderObject, item)
                      )}
                    </Fragment>
                  );
                });
              }
            })}
        </SGDocsContainer>
      </DocsFlexContainer>
    );
  }
}

UploadDocSG.propTypes = {
  fieldscustom: PropTypes.any,
  dispatch: PropTypes.any,
  selectedScreenIndex: PropTypes.any,
  getAllformVal: PropTypes.any,
  timeLine: PropTypes.array,
  currentDocScreen: PropTypes.object,
  goBack: PropTypes.func,
  formName: PropTypes.string,
  country_code: PropTypes.string,
  currentScreen: PropTypes.any,
  account_type: PropTypes.any,
  validate: PropTypes.any,
  device: PropTypes.string,
  clearFile: PropTypes.bool,
  hideUploadDocScreen: PropTypes.any,
  renderPOA: PropTypes.bool
};

function mapStateToProps(redux) {
  let {
    rootReducer: {
      uiTriggerState: { device },
      userStatusReducer: { additional_info }
    }
  } = redux;
  return {
    device,
    is_aadhar_details_accepted: get(additional_info, 'is_aadhar_details_accepted', false)
  };
}

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(
    {
      dispatch
    },
    dispatch
  )
)(UploadDocSG);
